import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { CustomerService } from '@services/customers/customer.service';
import { LegacyCompositionService } from '@services/legacy-compositions/legacy-composition.service';
import { CompositionService } from '@services/compositions/composition.service';
import { ImportService } from '@services/imports/import.service';
import { DataTableEvent } from '../../../components/data-table/data-table.component';

@Component({
    selector: 'app-import-connection',
    templateUrl: './import-connection.component.html',
    styleUrls: ['./import-connection.component.scss'],
    providers: [CustomerService, LegacyCompositionService, CompositionService, ImportService],
    standalone: false
})
export class ImportConnectionComponent implements OnInit {

  public title = '';

  public pageActions = [new PageAction({
    icon: 'subdirectory_arrow_left',
    title: 'Go to Import',
    callback: () => {
      this.router.navigate(['imports/', this.route.snapshot.params['id']]);
    }
  })];

  public columnsCustomer = [{ prop: 'company' }];
  public paramsCustomer: any;

  public columnsLegacyComposition = [{ prop: 'title', name: 'Title' }];
  public paramsLegacyComposition: any;

  public columnsComposition = [{ prop: 'title', name: 'Title' }];
  public paramsComposition: any;

  public columnsMetaImporter = [{ prop: 'title', name: 'Title' }];
  public connectedMetaImporter = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public customerService: CustomerService,
    public legacyCompositionService: LegacyCompositionService,
    public importService: ImportService,
    public compositionService: CompositionService
  ) {
    this.title = 'Connections of : ' + this.route.snapshot.queryParams['title'];
    this.paramsComposition = { importIds: this.route.snapshot.params['id'] };
    this.paramsLegacyComposition = { importIds: { $regex: this.route.snapshot.params['id'] } };
    this.paramsCustomer = { importIds: this.route.snapshot.params['id'] };
  }

  ngOnInit() {
    this.importService.get(this.route.snapshot.params['id']).then(importer => {
      if (!importer.assignableMenuItems || !importer.assignableMenuItems.length) {
        this.connectedMetaImporter.push({ title: 'unable to check metaImporter - no assignableMenuItems' });
        return;
      }
      this.importService.find(0, 100, { typeId: '5cac9c03ece329024573ac25' }).then(metaImporters => {
        if (metaImporters && metaImporters.data && metaImporters.data.length) {
          metaImporters.data.map(metaImporter => {
            const string = JSON.stringify(metaImporter.detail);
            importer.assignableMenuItems.map(item => {
              const regex = new RegExp(item.menuItemId)
              if (regex.test(string)) {
                this.connectedMetaImporter.push(metaImporter);
                return;
              }
            })
          });
        }
      })

    })
  }

  public onDetailCustomer(event: DataTableEvent): void {
    this.router.navigate(['customers', event.row._id]);
  }

  public onDetailLegacyComposition(event: DataTableEvent) {
    this.router.navigate(['legacy-compositions/', event.row._id]);
  }

  public onDetailComposition(event: DataTableEvent) {
    this.router.navigate(['compositions', event.row._id]);
  }

  public onDetailMetaImporter(event: DataTableEvent) {
    if (event.row._id) {
      this.router.navigate(['imports', event.row._id]);
    }
  }
}
